"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      borderBottom: '1px solid rgba(112, 112, 112, 0.12)'
    },
    alignment: function alignment(props) {
      if (props.vertical) {
        return {
          minHeight: '60px',
          height: '100%',
          width: '0px',
          borderBottom: 'none',
          borderLeft: '1px solid rgba(112, 112, 112, 0.12)',
          margin: '0 28px'
        };
      }
      return {};
    }
  };
}, {
  name: 'StyledDivider'
});
exports.useStyles = useStyles;